import { FEATURES } from '@belong/feature-toggles';
import { useFeatureToggles } from '@belong/feature-toggles/hooks';

export const useIsSessionsV2Enabled = (): boolean => {
  const { isFeatureOn } = useFeatureToggles();

  return isFeatureOn(FEATURES.LIVE_CHAT_SESSIONS_V2);
};
